import { SYSTEM_ROLES } from "@/app/components/constants";
import { RouteName } from "@/app/routing/routing";
import { confirmDeleteCallBack, isTaskListV2Enabled, triggerScheduledCallBackNotification } from "@/app/utils/Utils";
import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING } from "@/store/shared-actions/constants";
import "@agentx/agentx-mfe-wc-based";
import { OpenTaskListSortOptions, ScheduledTaskListSortOptions } from "@agentx/agentx-mfe-wc-based";
import { TasksType } from "@component-stores/TasksStore";
import { Router } from "@uuip/unified-ui-platform";
import { css } from "lit-element";
import { html, nothing } from "lit-html";
import { ifDefined } from "lit-html/directives/if-defined";
import { checkWebCall } from "./PopoverBlock";
import style from "./TasksAreaBlock.scss";
const getLoggedInRole = (userRoleString) => {
    switch (userRoleString) {
        case SYSTEM_ROLES.SUPERVISOR:
            return SYSTEM_ROLES.SUPERVISOR;
        case SYSTEM_ROLES.AGENT_AND_SUPERVISOR:
            return STORE.agent.userSelectedRole === SYSTEM_ROLES.SUPERVISOR
                ? SYSTEM_ROLES.SUPERVISOR
                : SYSTEM_ROLES.AGENT_AND_SUPERVISOR;
        default:
            return SYSTEM_ROLES.AGENT;
    }
};
const loggedInRole = () => {
    const role = STORE.agent.role;
    const userRole = STORE.agent.userRole;
    return userRole ? getLoggedInRole(userRole.join("_").toLocaleLowerCase()) : role;
};
const displayTaskList = () => {
    return loggedInRole() !== SYSTEM_ROLES.SUPERVISOR || STORE.agent.isMonitoringEnabled;
};
export const handleFireNotificationTaskAreaBlock = (e) => {
    if (!STORE.app.taskAreaCollapsed) {
        STORE.browserNotifications.fireNewOfferNotification(e.detail);
    }
    // STORE.browserNotifications.playSound :
    // 1. if the call is a web call and the feature flag CX-13578-webrtc-ringtone is enabled -> plays (/sounds/ringtone.mp3)
    // 2. if the call is not a web call -> plays default chime sound (/sounds/new_contact_sound.mp3)
    // 3. if its any other media type -> plays default chime sound (/sounds/new_contact_sound.mp3)
    STORE.browserNotifications.playSound(checkWebCall(e.detail.type));
};
const reactInteractionPopoverTemplate = (isRestyle) => {
    return html `
    <agentx-react-interaction-popover
      class="popover"
      agentId="${STORE.agent.agentId}"
      .taskMap="${STORE.agentContact.taskMapForPopover}"
      .agentconfig="${{
        isendcallenabled: STORE.agent.isEndCallEnabled,
        isAgentHandlingTask: STORE.agentContact.isAgentHandlingMoreThanOneTask(),
        isProgressive11SpecialModeEnabled: STORE.app.featureFlags.isProgressive11SpecialModeEnabled
    }}"
      .popoverConfig="${{
        isTaskList: STORE.app.isActiveTaskListVisible,
        isDarkMode: STORE.app.darkMode,
        isDesktopConsultToEntryPointDnEnabled: STORE.app.featureFlags.isDesktopConsultToEntryPointDnEnabled,
        isProgressiveCampaignEnabled: STORE.app.featureFlags.isProgressiveCampaignEnabled,
        isProgressiveCampaign1NEnabled: STORE.app.featureFlags.isProgressiveCampaign1NEnabled,
        isSuppressWebexCallingNotificationEnabled: STORE.app.featureFlags.isSuppressWebexCallingNotificationEnabled &&
            localStorage.getItem(DESKTOP_HIDE_WEBEX_CALLING_NOTIFICATIONS_SETTING) === "true",
        deviceType: STORE.agent.deviceType,
        isDesktopCpdViewEnabled: STORE.app.featureFlags.isDesktopCpdViewEnabled,
        isActivePopover: STORE.app.isActiveTaskListVisible,
        isPreviewCampaignEnabled: STORE.app.featureFlags.isPreviewCampaignEnabled,
        isRestyle
    }}"
      @ax-fire-notification="${handleFireNotificationTaskAreaBlock}"
      @ax-interaction-preview-api-failed="${(e) => {
        STORE.session.errorModal.setErrorDetails(e);
    }}"
    ></agentx-react-interaction-popover>
  `;
};
const taskListTemplate = (isRestyle, sortOption) => {
    return html `
    <agentx-wc-task-list
      .selectedId="${STORE.routing.currentRouteValues.params.taskId}"
      .agentId="${STORE.agent.agentId}"
      .isProgressiveCampaignEnabled="${STORE.app.featureFlags.isProgressiveCampaignEnabled}"
      .isProgressiveCampaign1NEnabled="${STORE.app.featureFlags.isProgressiveCampaign1NEnabled}"
      .taskList="${STORE.agentContact.taskArray}"
      .sortCriteria=${sortOption}
      .unreadMessages="${STORE.session.chat.unReadMessagesObject}"
      .hasOfferContact="${STORE.agentContact.newPopoverCount > 0}"
      .isInteractionModelOpen="${STORE.common.isInteractionModelOpen}"
      .clickEvent="${STORE.agentContact.getcheckReplies}"
      .newUnreadTaskMessage="${STORE.session.chat.getNewUnreadMessageId}"
      .isWxccScheduledCallBackEnabled="${STORE.app.featureFlags.isWxccScheduledCallBackEnabled}"
      .isDarkMode="${STORE.app.darkMode}"
      .monitoringOwnerName="${STORE.agentContact.monitoringOwnerName}"
      ?is-restyle="${isRestyle}"
      ?showEmptyState="${STORE.agentContact.taskArray.length === 0 &&
        Object.keys(STORE.agentContact.taskMapForPopover).length === 0 &&
        STORE.agentContact.newPopoverCount === 0}"
      @task-selected=${(e) => {
        const { taskId } = e.detail;
        STORE.routing.navigateTask(taskId);
    }}
      @handle-new-replies=${(e) => {
        STORE.agentContact.updateShowNewReply(e.detail.show);
        STORE.agentContact.updateShowArrowUp(e.detail.isShowUp);
    }}
    ></agentx-wc-task-list>
  `;
};
const newRepliesButtonTemplate = () => {
    return html ` <md-button @click="${() => STORE.agentContact.checkReplies()}" variant="primary">
    ${t("app:taskList.newReplies")} ${"  "}
    ${STORE.agentContact.showArrowUp
        ? html ` <md-icon class="arrow-icon arrow-up" name="icon-arrow-up_12"></md-icon> `
        : html ` <md-icon class="arrow-icon arrow-down" name="icon-arrow-down_12"></md-icon> `}
  </md-button>`;
};
const axActivityListWrapperTemplate = () => {
    return html `
    <div class="ax-activity-list-wrapper">
      ${STORE.agentContact.showNewReplyButton ? newRepliesButtonTemplate() : nothing}
    </div>
  `;
};
const reactContactHandledByAgentTemplate = (isRestyle = false) => {
    var _a;
    return html `
    <agentx-react-contact-handled-by-agent
      allowOutdial="${STORE.agent.isOutboundEnabledForTenant &&
        STORE.agent.isOutboundEnabledForAgent &&
        !STORE.agent.getIsMaskSensitiveDataEnabled}"
      lastcompletedtask="${STORE.agentContact.lastCompletedTask}"
      voicecount="${STORE.agent.channels.voiceCount}"
      chatcount="${STORE.agent.channels.chatCount}"
      emailcount="${STORE.agent.channels.emailCount}"
      socialcount="${STORE.agent.channels.socialCount}"
      agentId="${STORE.agent.agentId}"
      ?isActiveCall="${STORE.agentContact.isActiveCall}"
      isDarkMode="${STORE.app.darkMode}"
      .tasksStore=${STORE.tasks}
      @ax-active-call-error="${(e) => STORE.session.errorModal.setErrorDetails(e)}"
      webRtcStatus="${STORE.agent.webRtcStatus}"
      isWebRTCEnabled="${STORE.app.featureFlags.isWebRTCEnabled}"
      isMaskSensitiveDataEnabled="${STORE.agent.getIsMaskSensitiveDataEnabled}"
      deviceType="${ifDefined((_a = STORE.agent.deviceType) !== null && _a !== void 0 ? _a : undefined)}"
      orgId="${STORE.agent.orgId}"
      ?isRestyle="${isRestyle}"
      isPreviewCampaignEnabled="${STORE.app.featureFlags.isPreviewCampaignEnabled}"
    ></agentx-react-contact-handled-by-agent>
  `;
};
const renderOpenTaskList = (isRestyle = false, sortOption = undefined) => {
    return html `
    <div class="task-list-wrapper" role="region" aria-label=${t("app:taskBar:taskRegionLabel")}>
      <div class="${!STORE.app.isActiveTaskListVisible ? "hide" : "show"}">
        ${reactInteractionPopoverTemplate(isRestyle)}
      </div>
      ${taskListTemplate(isRestyle, sortOption)} ${axActivityListWrapperTemplate()}
    </div>
  `;
};
const renderSplitOpenAndClosedTaskList = () => {
    return html `
    <div class="agentx-task-area-width-holder">
      ${renderOpenTaskList()} ${STORE.app.isStationLoginSuccess ? reactContactHandledByAgentTemplate() : nothing}
    </div>
  `;
};
const renderOpenTaskListV2 = () => {
    return html `
    <agentx-wc-task-list-panel-wrapper row-count="${STORE.agentContact.taskArray.length}">
      <agentx-wc-task-list-panel-wrapper-sort
        slot="sort-menu"
        .sortOptions=${OpenTaskListSortOptions()}
        @sort-change=${(event) => {
        STORE.agentContact.setOpenTaskListSortOption(event.detail.sortValue);
    }}
      ></agentx-wc-task-list-panel-wrapper-sort>
      ${renderOpenTaskList(true, STORE.agentContact.openTaskListSortOption)}
    </agentx-wc-task-list-panel-wrapper>
  `;
};
const queuedTasksTemplate = () => {
    if (!STORE.app.featureFlags.isDigitalChannelCherryPickEnabled) {
        return undefined;
    }
    return html `
    <agentx-wc-tasks-tab-list-panel
      .tasksStore=${STORE.tasks}
      .manualAssignCapacity=${{
        chat: STORE.agent.channels.maChatCount,
        telephony: STORE.agent.channels.maVoiceCount,
        email: STORE.agent.channels.maEmailCount,
        social: STORE.agent.channels.maSocialCount
    }}
      tasks-type=${TasksType.Queued}
      @task-selected=${(e) => {
        e.stopPropagation();
        const { taskId } = e.detail;
        STORE.routing.navigateTask(taskId);
    }}
    >
    </agentx-wc-tasks-tab-list-panel>
  `;
};
const renderScheduledTaskList = () => {
    return html `
    <div
      class="scheduled-task-list-wrapper"
      style="height:90%"
      role="region"
      aria-label=${t("app:taskBar:taskRegionLabel")}
    >
      <agentx-wc-personal-callback
        meUserId=${STORE.agent.agentId}
        assigneeAgent=${STORE.agent.agentId}
        sortOrder=${STORE.scheduledCallback.personalCallbackSortOrder}
        sortBy=${STORE.scheduledCallback.personalCallbackSortBy}
        .updatedCallbackDetails=${STORE.scheduledCallback.updatedCallbackDetail}
        @ax-confirm-delete-callback=${(e) => confirmDeleteCallBack(e)}
        @personal-callbacks-count-update=${(e) => {
        STORE.scheduledCallback.updatePersonalCallbackCount(e.detail.count);
    }}
        @ax-trigger-notification=${(e) => {
        triggerScheduledCallBackNotification(e);
    }}
      ></agentx-wc-personal-callback>
    </div>
  `;
};
const scheduledTasksTemplate = () => {
    if (!STORE.app.featureFlags.isWxccScheduledPersonalCallBackEnabled) {
        return undefined;
    }
    return html `
    <agentx-wc-task-list-panel-wrapper
      tasks-type=${TasksType.Scheduled}
      row-count="${STORE.scheduledCallback.personalCallbackCount}"
    >
      <agentx-wc-task-list-panel-wrapper-sort
        slot="sort-menu"
        .sortOptions=${ScheduledTaskListSortOptions()}
        @sort-change=${(_event) => {
        // TO BE DONE -> set the sort option for scheduled tasks in store
        STORE.scheduledCallback.updatePersonalCallbackSortBy(_event.detail.sortValue);
        STORE.scheduledCallback.updatePersonalCallbackSortOrder(_event.detail.sortValue === "assignedTime" ? "desc" : "asc");
    }}
      ></agentx-wc-task-list-panel-wrapper-sort>
      ${renderScheduledTaskList()}
    </agentx-wc-task-list-panel-wrapper>
  `;
};
const renderClosedTaskListV2 = () => {
    //Temporarily return existing closed task list
    return html ` <agentx-wc-task-list-panel-wrapper
    row-count="${STORE.tasks.closedTasks.size}"
    tasks-type=${TasksType.Closed}
  >
    ${reactContactHandledByAgentTemplate(true)}
  </agentx-wc-task-list-panel-wrapper>`;
};
const renderTabbedTaskList = (taskId) => {
    var _a;
    const selectedTaskType = taskId
        ? ((_a = STORE.tasks.getTaskType(taskId)) !== null && _a !== void 0 ? _a : STORE.tasks.lastSelectedTaskType)
        : STORE.tasks.lastSelectedTaskType;
    return html `
    <agentx-wc-panel-frame class="agentx-task-area-width-holder" heading="${t("app:tasks.myWorkspace")}">
      ${STORE.app.featureFlags.isWxccScheduledCallBackEnabled
        ? html `<agentx-wc-tasks-panel-header-button
            slot="header-extra-content"
            @open-schedule-callback-modal="${(e) => STORE.scheduledCallback.updateScheduleCallBackModalOnTrigger(e.detail)}"
          ></agentx-wc-tasks-panel-header-button>`
        : nothing}
      <agentx-wc-tasks-tab-list
        .tasksStore=${STORE.tasks}
        .openTasksTemplate=${renderOpenTaskListV2()}
        .closedTasksTemplate=${renderClosedTaskListV2()}
        .queuedTasksTemplate=${queuedTasksTemplate()}
        .scheduledTasksTemplate=${scheduledTasksTemplate()}
        .selectedTab=${selectedTaskType !== null && selectedTaskType !== void 0 ? selectedTaskType : TasksType.Active}
        ?is-queued-tasks-enabled=${STORE.app.featureFlags.isDigitalChannelCherryPickEnabled &&
        STORE.agent.canManuallyAssignDigitalTasks}
        ?is-scheduled-tasks-enabled=${STORE.app.featureFlags.isWxccScheduledPersonalCallBackEnabled}
        @assign-task-error="${(e) => STORE.session.errorModal.setErrorDetails(e)}"
        @task-list-wide-mode="${(e) => {
        STORE.app.setTaskAreaExtraWidth(e.detail.wideMode);
    }}"
      ></agentx-wc-tasks-tab-list>
    </agentx-wc-panel-frame>
  `;
};
const collapseAreaTemplate = (taskId) => {
    return html `
    <agentx-wc-collapse-area
      .direction="${"left"}"
      ?collapsed=${STORE.app.taskAreaCollapsed}
      .forceTogglerVisibilityOnMouseOverSelectors="${`agentx-wc-navigation`}"
      @toggle="${() => STORE.app.toggleTaskAreaCollapse()}"
    >
      ${isTaskListV2Enabled() ? renderTabbedTaskList(taskId) : renderSplitOpenAndClosedTaskList()}
    </agentx-wc-collapse-area>
  `;
};
const TasksAreaBlock = () => {
    let taskId;
    if (STORE.routing.currentRouteName === RouteName.TASKPANEL) {
        taskId = STORE.routing.currentRouteValues.params.taskId;
    }
    return new Router.RouterView.Block({
        template: html `
      <!-- TASKS AREA -->
      <div
        class=${`
          agentx-task-area          
          ${STORE.common.isNavBarOpen ? "left-nav-open" : ""}
          ${STORE.common.isInteractionModelOpen ? "interaction-modal-opened" : ""}
          ${STORE.app.taskAreaExtraWidth ? "wide-mode" : ""}
          `}
      >
        ${displayTaskList() ? collapseAreaTemplate(taskId) : nothing}
      </div>
    `,
        styles: [
            style,
            css `
        .agentx-task-area {
          grid-area: tasks; /*grid*/
        }
      `
        ]
    });
};
export default TasksAreaBlock;
